@if (parking.length > 0) {
  @if (!isDialogMode) {
    <!-- Layout page par défaut -->
    <div class="tw-flex tw-column">
      @if (showTitle) {
        <div>
          <div>
            <strong class="md-headline">{{ 'parking.likeReserve' | translate }}</strong>
          </div>
        </div>
      }
      @for (prk of parking; track prk; let i = $index) {
        <div class="tw-flex tw-row mat-elevation-z1">
          @if (prk.logo_url) {
            <div style="flex-grow: 1; padding: 8px">
              <img style="max-width: 66px" src="{{ prk.logo_url }}" />
            </div>
          } @else {
            <div
              style="
                flex-grow: 1;
                padding: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px rgba(128, 128, 128, 0.38) solid;
              ">
              <mat-icon>local_parking</mat-icon>
            </div>
          }
          <div class="tw-flex tw-column" style="flex-grow: 5">
            <div class="tw-flex tw-row" style="justify-content: space-between">
              <div style="flex-grow: 4; margin: 5px">
                <strong style="font-size: 20px">{{ prk.name }}</strong>
                <p style="margin: 0">
                  {{ prk.address }}
                  <br />
                </p>
              </div>
              <div class="tw-flex tw-column" style="margin: 5px; justify-content: right">
                <span>{{ 'parking.priceByDay' | translate }}</span>
                <span style="color: green; font-size: 23px">
                  {{ prk.amount / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                </span>
              </div>
            </div>
            <mat-divider class="pl-divider" style="margin: 2px !important"></mat-divider>
            <div class="tw-flex" style="justify-content: right; margin: 0 10px">
              <div class="tw-flex tw-flex-flow-row-wrap">
                <mat-checkbox [(ngModel)]="prk.datesSelected[prk.date].bool" (ngModelChange)="createHold()">
                  <span>{{ prk.date | twDatePipe: 'longDate' }}</span>
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <!-- Layout dialog compact -->
    @for (prk of parking; track prk.id) {
      <div
        style="
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 12px 16px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 12px;
        ">
        <mat-icon style="color: #555; flex-shrink: 0">local_parking</mat-icon>
        <div style="flex: 1">
          <div style="font-weight: 600">{{ prk.name }}</div>
          @if (parking.length > 1) {
            <div style="font-size: 0.8rem; color: #666">{{ prk.date | twDatePipe: 'longDate' }}</div>
          }
          <div style="font-weight: bold">
            {{ prk.amount / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
            {{ '' | libTranslateLang: '/ day' : '/ jour' }}
          </div>
        </div>
        @if (parking.length > 1) {
          <mat-checkbox [(ngModel)]="dialogCheckState[prk.id]" (ngModelChange)="onDialogCheckChange()"></mat-checkbox>
        }
      </div>
    }
  }
}
